import { render } from "./emplacements_tab.vue?vue&type=template&id=2633f4fa"
import script from "./emplacements_tab.vue?vue&type=script&lang=js"
export * from "./emplacements_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__